import { useQuery } from '@apollo/client';

import { gql } from 'src/__generated__';

export const GET_CAREER_HISTORY = gql(`
  query GetRoles {
    viewer {
      _id
      roles {
        ...role
      }
      yearsOfExperience {
        newToWorkforce
      }
    }
  }
`);
export function useCareerHistoryData() {
  const { data: rolesData, loading } = useQuery(GET_CAREER_HISTORY);
  const roles = rolesData?.viewer?.roles || [];
  const isNewToWorkforce =
    rolesData?.viewer?.yearsOfExperience?.newToWorkforce ?? false;

  return { roles, isNewToWorkforce, loading };
}
